import Swiper from 'swiper'

class Slider {
  constructor({ parent, buttonInactiveClass }, swiperOptions) {
    this.parent = parent
    this.sliderEl = parent.querySelector('.swiper')

    this.swiper = new Swiper(
      this.sliderEl,
      swiperOptions
        ? swiperOptions
        : {
            slidesPerView: 1,
            breakpoints: {
              768: {
                slidesPerView: 2,
              },
              1300: {
                slidesPerView: 3,
              },
            },
            grabCursor: true,
          }
    )

    this.buttonInactiveClass = buttonInactiveClass

    this.sliderIndex = 0

    this.previousSlideButton = parent.querySelector('.prev-button')
    this.nextSlideButton = parent.querySelector('.next-button')

    this.currentSlideEl = parent.querySelector('.swiper__current-slide')

    this.setMaxSlidesValue()
    this.updateCurrentSlideNumber()
    this.updateArrowsState()
    this.addListeners()
  }

  addListeners() {
    this.swiper.on('slideChange', this.updateOnSlideChange.bind(this))
    this.swiper.on('resize', this.updateMaxSlides.bind(this))
    this.previousSlideButton.addEventListener('click', this.previous.bind(this))
    this.nextSlideButton.addEventListener('click', this.next.bind(this))
  }

  updateOnSlideChange() {
    this.updateSliderIndex()
    this.updateArrowsState()
    this.updateCurrentSlideNumber()
  }

  updateSliderIndex() {
    this.sliderIndex = this.swiper.realIndex
  }

  updateArrowsState() {
    if (this.swiper.isBeginning && !this.swiper.isEnd) {
      this.previousSlideButton.classList.add(this.buttonInactiveClass)
      this.nextSlideButton.classList.remove(this.buttonInactiveClass)
    }

    if (this.swiper.isEnd && !this.swiper.isBeginning) {
      this.nextSlideButton.classList.add(this.buttonInactiveClass)
      this.previousSlideButton.classList.remove(this.buttonInactiveClass)
    }

    if (!this.swiper.isEnd && !this.swiper.isBeginning) {
      this.nextSlideButton.classList.remove(this.buttonInactiveClass)
      this.previousSlideButton.classList.remove(this.buttonInactiveClass)
    }
  }

  updateMaxSlides() {
    this.setMaxSlidesValue()
  }

  updateCurrentSlideNumber() {
    this.currentSlideEl.innerHTML = this.sliderIndex + 1
  }

  setMaxSlidesValue() {
    this.maxSlidesEl = this.parent.querySelector('.swiper__max-slides')

    if (this.swiper.currentBreakpoint === '768') {
      this.maxSlidesEl.innerHTML = this.swiper.slides.length - 1
    }

    if (this.swiper.currentBreakpoint === '1300') {
      this.maxSlidesEl.innerHTML = this.swiper.slides.length - 2
    }
  }

  next() {
    if (!this.swiper.isEnd) {
      this.swiper.slideNext(500)
    }
  }

  previous() {
    if (!this.swiper.isBeginning) {
      this.swiper.slidePrev(500)
    }
  }
}

export default Slider
